import {Modal} from "bootstrap";

window.showModal = function (modalSelector) {
  const modal = new Modal(document.querySelector(modalSelector));
  modal.show();
};

window.hideModal = function (modalSelector) {
  const modal = Modal.getInstance(document.querySelector(modalSelector));
  modal.hide();
};
